import { crudApi } from "../../../helpers/api_helper";
import { TIPO_ESPACO } from "../../../helpers/url_helper";

export default crudApi(TIPO_ESPACO);